import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocation } from 'react-router-dom';
import LogoMiBanco from '@assets/icons/logo-mi-banco-footer-green.svg';
import './footer.scss';
import { useMediaQuery } from '@mui/material';
const Footer = () => {
    const currentYear = new Date().getFullYear();
    const { pathname } = useLocation();
    const isHome = pathname === '/';
    const isMobile = useMediaQuery('(max-width: 600px)');
    return (_jsx("footer", { className: `footer${isHome ? ' footer--home' : ''} ${isMobile ? ' ' : 'footer--mobile'}`, children: _jsxs("div", { className: 'footer-center', children: [_jsx("div", { className: 'footer_image', children: _jsx("img", { src: LogoMiBanco, alt: "logo-mibanco-footer", loading: "lazy" }) }), _jsx("div", { className: 'footer-center_info', children: _jsx("span", { children: "\u00A9 2026 Mibanco - Todos los derechos reservados. Mibanco - Banco de la microempresa S.A. RUC 20382036655. Av. Rep\u00FAblica de Panam\u00E1 Nro. 4575, Urb. Cercado, Lima \u2013 Lima \u2013 Surquillo" }) })] }) }));
};
export default Footer;
